import { LogOutput, LogLevel } from './logger.service';
import { LogRelayService } from './log-relay.service';
import { environment } from '@env';

export function cloudWatchLogOutputFactory(relay: LogRelayService): LogOutput {
  return (source, level, ...objects) => {
    const logEntry = {
      source,
      level: LogLevel[level],
      message: objects.map(o => (typeof o === 'string' ? o : JSON.stringify(o))).join(' '),
      meta: objects.length > 1 ? objects.slice(1) : undefined,
      time: new Date().toISOString(),
      logGroup: environment.logGroupName,
      logStream: environment.logStreamName
    };
    // Errors/warnings: send immediately, others: batch
    if (level >= LogLevel.Warning) {
      relay.logToCloud(logEntry, true);
    } else {
      relay.logToCloud(logEntry, false);
    }
  };
}
